module.exports = {"340371400":"高新技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340371.json
// module id = 1171
// module chunks = 0